/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-truckin': {
    width: 12,
    height: 11,
    viewBox: '0 0 12 11',
    data: '<defs><path pid="0" d="M5.534 1.008a.456.456 0 0 1 .396.036l4.285 2.577.064.047a.456.456 0 0 1 .157.344v6.51l-.008.082a.456.456 0 0 1-.449.375H1.41l-.082-.008a.456.456 0 0 1-.374-.449l.007-.082a.456.456 0 0 1 .45-.374h8.113V4.27L5.695 1.967 1.867 4.27v2.188l-.008.082a.456.456 0 0 1-.905-.082V4.012l.007-.078a.456.456 0 0 1 .214-.313l4.284-2.577zm-.18 3.58l.068.047 1.808 1.49a.457.457 0 0 1 .067.635l-.065.067-1.807 1.512a.456.456 0 0 1-.644-.642l.058-.058 1.385-1.16-1.382-1.14a.456.456 0 0 1-.109-.574l.047-.068a.456.456 0 0 1 .574-.109z" id="svgicon-icon-truckin-a"/></defs><use _fill="#376F99" xlink:href="#svgicon-icon-truckin-a" transform="matrix(-1 0 0 1 11.5 0)" fill-rule="evenodd"/>'
  }
})
